import { UserRound } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

// Uses the brief's documented mailto fallback: there is no existing,
// confirmed web_form_id/CRM schema in this codebase for an "update your
// details" submission (the only precedent, CustomerReviewPage.jsx, posts to
// a form-specific endpoint that must be pre-registered with TananTech). This
// can be swapped for a direct CRM submission once that schema is confirmed.
const MAILTO_HREF = `mailto:info@yourclaimmatters.co.uk?subject=${encodeURIComponent(
  'Request to update my contact details'
)}`

const UpdateDetailsCta = () => (
  <Card className="border-border/60 flex-col items-start gap-4 border bg-[#fff3ec] p-5 sm:flex-row sm:items-center sm:p-6">
    <div className="flex-1">
      <div className="flex items-center gap-3">
        <UserRound
          className="h-6 w-6 shrink-0 text-[#FF914D]"
          aria-hidden="true"
        />
        <h2 className="text-foreground text-lg font-bold sm:text-xl">
          Changed your details?
        </h2>
      </div>
      <p className="text-foreground mt-1 text-sm leading-relaxed sm:text-base">
        Let us know if your name, address, mobile number or email has changed.
      </p>
    </div>
    <Button
      asChild
      className="w-full shrink-0 bg-[#FF914D] font-bold text-white hover:bg-[#FF914D]/90 sm:w-auto"
    >
      <a href={MAILTO_HREF}>Update your details</a>
    </Button>
  </Card>
)

export default UpdateDetailsCta
